export { default as Page } from './Page'
export type { PageProps } from './Page'
